// Shows how long a booking's deposit has gone unpaid (status === pending_payment).
export function unpaidDays(b) {
  if (b?.status !== "pending_payment" || !b?.created_at) return null;
  const created = new Date(b.created_at);
  if (isNaN(created.getTime())) return null;
  return Math.max(0, Math.floor((Date.now() - created.getTime()) / 86400000));
}

export function UnpaidBadge({ booking, className = "" }) {
  const days = unpaidDays(booking);
  if (days === null) return null;
  const tone = days >= 7
    ? "bg-[#C2401F] text-white"
    : days >= 3
      ? "bg-[#F0A33D] text-[#12263A]"
      : "bg-[#FCE3D6] text-[#A87E28]";
  const label = days === 0 ? "Unpaid today" : `Unpaid ${days}d`;
  return (
    <span
      data-testid={`unpaid-badge-${booking.reference}`}
      title={`Deposit unpaid for ${days} day${days === 1 ? "" : "s"}`}
      className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider rounded-full whitespace-nowrap ${tone} ${className}`}>
      {label}
    </span>
  );
}
